/* tslint:disable */
/* eslint-disable */
/**
 * SDPS Preprocessing API
 * The pre-processing service manages batches submitted to the SDP.  <br> There are two services available: Contents and Events
 *
 * The version of the OpenAPI document: 0.1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * A DIP created from a Transfer
 * @export
 * @interface DIP
 */
export interface DIP {
    /**
     * Identifier of DIP
     * @type {string}
     * @memberof DIP
     */
    dipId?: string;
    /**
     * 
     * @type {string}
     * @memberof DIP
     */
    status: DIPStatusEnum;
    /**
     * 
     * @type {Date}
     * @memberof DIP
     */
    statusUpdatedAt: Date;
    /**
     * Identifier of transfer
     * @type {string}
     * @memberof DIP
     */
    transferId?: string;
}


/**
 * @export
 */
export const DIPStatusEnum = {
    Created: 'Created',
    Validated: 'Validated',
    Failed: 'Failed',
    SentToStorage: 'Sent to Storage',
    Stored: 'Stored',
    DisseminationRequested: 'Dissemination Requested',
    Disseminated: 'Disseminated',
    ReingestRequested: 'Reingest Requested',
    PreProcessing: 'Pre-Processing',
    ReadyForIngest: 'Ready for Ingest',
    Ingesting: 'Ingesting',
    PendingReview: 'Pending Review',
    Rejected: 'Rejected'
} as const;
export type DIPStatusEnum = typeof DIPStatusEnum[keyof typeof DIPStatusEnum];


/**
 * Check if a given object implements the DIP interface.
 */
export function instanceOfDIP(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "statusUpdatedAt" in value;

    return isInstance;
}

export function DIPFromJSON(json: any): DIP {
    return DIPFromJSONTyped(json, false);
}

export function DIPFromJSONTyped(json: any, ignoreDiscriminator: boolean): DIP {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dipId': !exists(json, 'dip_id') ? undefined : json['dip_id'],
        'status': json['status'],
        'statusUpdatedAt': (new Date(json['status_updated_at'])),
        'transferId': !exists(json, 'transfer_id') ? undefined : json['transfer_id'],
    };
}

export function DIPToJSON(value?: DIP | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dip_id': value.dipId,
        'status': value.status,
        'status_updated_at': (value.statusUpdatedAt.toISOString()),
        'transfer_id': value.transferId,
    };
}

